/* eslint-disable import/prefer-default-export */
export const formatConnectorType = (connectorType) => {
  const connectorTypeFormatted = [];

  connectorType?.map((v) => {
    if (v === "Straight") {
      connectorTypeFormatted.push("STRAIGHT_CONNECTOR", "STRAIGHT_CONNECTORS");
    }
    if (v === "Angled") {
      connectorTypeFormatted.push("ROTATABLE_RIGHT-ANGLED_CONNS", "ROTATABLE_RH_ANGLED_CONNECTOR");
    }
    if (v === "Free Lead") {
      connectorTypeFormatted.push("CABLE_WITH_STRIPPED_END");
    }
    if (v !== "Straight" && v !== "Angled" && v !== "Free Lead") {
      connectorTypeFormatted.push(v);
    }
    return -1;
  });
  return connectorTypeFormatted;
};

export const formatMotorEncoder = (motorEncoder) => {
  const motorEncoderFormatted = [];

  motorEncoder?.map((v) => {
    if (v === "single_turn") {
      motorEncoderFormatted.push(
        "20_BITS_1_TURN_ABS_ENCODER",
        "SINGLE_TURN_SINCOS_HIPERFACE",
        "ABS_1_TURN_SINCOS_HIPERFACE",
        "ABS_SINGLE_TURN_HIPERFACE_DSL",
        "23_BTS_OPTIC_INCREMENTAL_NCODR"
      );
    }
    if (v === "multi_turn") {
      motorEncoderFormatted.push(
        "20_BITS_MULTI_TURN_ABS_ENCODER",
        "MULTITURN_SINCOS_HIPERFACE",
        "ABS_MULTITURN_SINCOS_HIPERFACE",
        "ABS_MULTITURN_HIPERFACE_DSL",
        "23_BITS_OPTIC_MULTITURN_ENCDR",
        "17_BITS_MGNTC_MULTITURN_ENCDR"
      );
    }
    if (v !== "SingleTurn" && v !== "MultiTurn") {
      motorEncoderFormatted.push(v);
    }
    return -1;
  });
  return motorEncoderFormatted;
};

export const formatShaftEnd = (shaftEnd) => {
  const shaftEndFormatted = [];

  shaftEnd?.map((v) => {
    if (v === "keyed") {
      shaftEndFormatted.push("KEYED", "PARALLEL_KEY");
    }
    if (v === "smooth_shaft") {
      shaftEndFormatted.push("SMOOTH_SHAFT", "UNTAPPED");
    }
    if (v !== "keyed" && v !== "smooth_shaft") {
      shaftEndFormatted.push(v);
    }
    return -1;
  });
  return shaftEndFormatted;
};

export const formatNbPhases = (nbPhases) => {
  const nbPhasesFormatted = [];

  nbPhases?.map((v) => {
    if (v === "1 Phase") {
      nbPhasesFormatted.push("SINGLE_PHASE", "SINGLE_OR_THREE_PHASES");
    }
    if (v === "2 Phases") {
      nbPhasesFormatted.push("2_PHASES");
    }
    if (v === "3 Phases") {
      nbPhasesFormatted.push("3_PHASES", "THREE_PHASE", "SINGLE_OR_THREE_PHASES");
    }
    if (v !== "1 Phase" && v !== "2 Phases" && v !== "3 Phases") {
      nbPhasesFormatted.push(v);
    }
    return -1;
  });
  return nbPhasesFormatted;
};

export const formatDriveInterfaces = (driveInterfaces) =>
  // get what's before the comma
  driveInterfaces
    ?.map((val) => val.split(",")[0])
    // remove duplicates
    ?.filter((val, index, self) => self.indexOf(val) === index)
    // remove null
    ?.filter((val) => val !== null)
    ?.sort() || [];
